import { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import {
  // flatten,
  // spread,
  mergeWith,
  groupBy,
  flow,
  mapValues,
  isArray,
  // isObject,
  values,
  // map,
} from "lodash";

import { LabelLangString } from "component/LabelLang/label-lang";
import { useSelector } from "react-redux";
import { staticColorArray } from "constants/ColorConstant";
import { YearTypeConst } from "constants/YearTypeConstant";
// import IconFullscreen from "svg-icons/full-screen-icon";
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
// import IconFullscreenExit from "svg-icons/exit-full-screen-icon";

export default function ({
  allDataChart,
  years,
  indicatorName = "",
  yearType = null,
}) {
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const dir = useSelector(({ theme }) => theme.direction);
  const [xInterval, setXInterval] = useState(0);
  // const handle = useFullScreenHandle();
  // const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const windowWidth = window.innerWidth;

    const calculatedXInterval =
      windowWidth >= 1200
        ? Math.ceil(years.length / 11) - 1
        : Math.ceil(years.length / 11);

    setXInterval(calculatedXInterval);
  }, [years, window.innerWidth]);
  var allYears = [...years.slice(0, 0), ...years.slice(1)];
  var finalResult = allDataChart.map((item, i) => {
    return allYears.flatMap((el, index) => {
      const currentYear = el.headerName;
      const getRecordWithYear = item.find(
        (att) =>
          att.month + " " + att.quarter + " " + att.year.toString() ===
          currentYear
      );
      const currentYearNoSpace = currentYear.replaceAll(" ", "");
      const yearHeaderName =
        yearType && yearType === YearTypeConst.Maly
          ? `${(
              currentYearNoSpace - 1
            ).toString()}/${currentYearNoSpace.toString()}`
          : currentYear.toString();
      if (getRecordWithYear) {
        return {
          year: yearHeaderName,
          id: getRecordWithYear.year,

          [`indicator${i}`]: getRecordWithYear.name,
          [`value${i}`]: Math.round(getRecordWithYear.value),
          [`translations${i}`]: getRecordWithYear.translations,
        };
      } else {
        return {
          year: yearHeaderName,
          id: currentYear,

          [`indicator${i}`]: item[0].name,
          [`value${i}`]: null,
          [`translations${i}`]: item[0].translations,
        };
      }
    });
  });

  var result = flow(
    (arr) => groupBy(arr, "year"),
    (g) =>
      mapValues(g, (arr) =>
        mergeWith(...arr, (objV, srcV) => {
          if (isArray(objV)) return objV.concat(srcV);
        })
      ),
    values
  );

  var final = result(finalResult).flat();

  const indicatorRendering = (indicator, translations) => {
    const subject = LabelLangString({
      id: "name", // change it
      currentLocale: currentLocale,
      defaultValue: indicator,
      translations: translations,
    });
    return subject;
  };
  return (
    <>
      {/* {handle.active === false && (
        <div style={{ cursor: "pointer" }}>
          <IconFullscreen
            onClick={handle.enter}
            style={{
              float: currentLocale === "ar" ? "left" : "right",
            }}
          />
        </div>
      )} */}
      {/* <FullScreen handle={handle} onChange={(e) => console.log(e)}> */}
      <h6 className={`text-center text-black-50 my-2`}>{indicatorName}</h6>

      {/* {handle.active === true && (
          <div style={{ cursor: "pointer" }}>
            <IconFullscreenExit
              onClick={handle.exit}
              style={{
                float: currentLocale === "ar" ? "left" : "right",
                marginLeft: currentLocale === "ar" ? "10px" : "0px",
                marginTop: "10px",
                marginRight: currentLocale === "ar" ? "0px" : "10px",
                cursor: "pointer !important",
              }}
            />
          </div>
        )} */}
      <ResponsiveContainer width="99%" height="90%" key={indicatorName}>
        <LineChart
          data={final}
          style={{ textAlign: "start" }}
          margin={{ top: 15, right: 30, left: dir === "rtl" ? 20 : -20 }}
        >
          <CartesianGrid
            strokeDasharray="1"
            verticalCoordinatesGenerator={(props) => []}
          />
          <XAxis
            axisLine={false}
            tickLine={false}
            tickAlign="start"
            textAnchor="center"
            scale="auto"
            interval={xInterval}
            dataKey={"year"}
            tick={<CustomizedXaxisTick />}
          />
          <YAxis
            axisLine={false}
            textAnchor="center"
            tick={<CustomizedYaxisTick />}
            domain={["auto", "auto"]}
          />
          <Tooltip />
          <Legend
            wrapperStyle={{
              paddingTop: "35px",
            }}
          />
          {allDataChart.map((item, index) => {
            return (
              <Line
                key={index}
                type="monotone"
                dataKey={`value${index}`}
                // name={finalResult[0][`indicator${index}`]}
                name={indicatorRendering(
                  final[0][`indicator${index}`],
                  final[0][`translations${index}`]
                )}
                stroke={staticColorArray[index]}
                connectNulls
              />
            );
          })}
        </LineChart>
      </ResponsiveContainer>
      {/* </FullScreen> */}
    </>
  );
}
const CustomizedXaxisTick = (props) => {
  const dir = useSelector(({ theme }) => theme.direction);

  // const yPlacing = dir === "rtl" ? 15 : 100;
  const { x, y, payload } = props;
  const { value } = payload;
  var splittedValueArr = value.split(" ");
  splittedValueArr = splittedValueArr.filter((n) => n);
  return (
    <g transform={`translate(${x},${y})`}>
      <text x="0" y="0" dy="15" fill="#666" transform="rotate(0)">
        {splittedValueArr.map((obj, index) => {
          return (
            <tspan
              key={index}
              x={dir === "rtl" ? "15" : "-40"}
              dy={(15 + index).toString()}
            >
              {obj}
            </tspan>
          );
        })}
      </text>
    </g>
  );
};

const CustomizedYaxisTick = (props) => {
  const dir = useSelector(({ theme }) => theme.direction);

  const { x, y, payload } = props;
  const { value } = payload;
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={dir === "rtl" ? "-5" : "-30"}
        y="5"
        dy="0"
        fill="#666"
        transform="rotate(0)"
      >
        {value}
      </text>
    </g>
  );
};
